import { render, staticRenderFns } from "./Map-7-museums.vue?vue&type=template&id=737fe0e4&"
import script from "./Map-7-museums.vue?vue&type=script&lang=js&"
export * from "./Map-7-museums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports